import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {CopyableUrlInput} from './CopyableUrlInput'
import {ServiceQRCodeSection} from './ServiceQRCodeSection'

import {SideModal} from '~/components/general/modal/SideModal'
import {Container} from '~/components/general/container/Container'
import {Typography} from '~/components/general/typography/Typography'

type PublicServiceUrlModalProps = {
  isVisible: boolean
  onClose: () => void
  serviceId: string | null
}

export const PublicServiceUrlModal: React.FC<PublicServiceUrlModalProps> = ({
  isVisible,
  onClose,
  serviceId,
}) => {
  const {t} = useTranslation()

  const publicUrl = useMemo(() => {
    if (!serviceId) return ''
    return `${window.location.origin}/app/bookings/services/${serviceId}`
  }, [serviceId])

  return (
    <SideModal
      isVisible={isVisible}
      onClose={onClose}
      header={
        <Container>
          <Typography size="lg" weight="medium">
            {t('Public service URL')}
          </Typography>
        </Container>
      }>
      <Container flex direction="column" spacing={3}>
        <Container flex direction="column" spacing={1}>
          <Typography>
            {t('Share this link with patients to book this service')}
          </Typography>
          <CopyableUrlInput url={publicUrl} />
        </Container>

        <ServiceQRCodeSection url={publicUrl} />
      </Container>
    </SideModal>
  )
}
